import { gql } from '@apollo/client';

export const GET_ORG_PROFILE_VISIBILITY_SETTINGS = gql`
  query GetOrgProfileVisibilitySettings($orgId: Int!) {
    getOrgProfileVisibilitySettings(orgId: $orgId) {
      orgId
      showPhone
      showContactEmail
      showFullAddress
      showYearEstablished
      showChildEnrichmentStatement
      showWebsite
      showSocialMedia
      showSeasonality
    }
  }
`;
